import React from 'react';

// Meta's Business Tools Terms (§3.b) require a clear, prominent notice on
// EVERY page where advertising pixels run, linking to an explanation of
// third-party tracking and how to opt out. Branded partner and bridge pages
// don't render the site footer, so they include this line instead.
interface TrackingNoticeLinksProps {
  // 'dark' for light text on a dark footer, 'light' for dark text on white.
  tone?: 'dark' | 'light';
}
export function TrackingNoticeLinks({
  tone = 'dark'
}: TrackingNoticeLinksProps) {
  const linkClass = tone === 'dark' ? 'underline hover:text-white transition-colors' : 'underline hover:text-[#e8594f] transition-colors';
  return <p className={tone === 'dark' ? 'text-gray-500' : 'text-gray-500'} data-id="element-985" data-mp="19eux6a0unt4w">
      This page uses cookies and pixels from third parties, including Meta, for
      advertising and measurement.{' '}
      <a href="/cookie-policy" className={linkClass} data-id="element-986" data-mp="1ifks7biadfhk">
        Cookie Policy
      </a>{' '}
      ·{' '}
      <a href="/privacy-policy" className={linkClass} data-id="element-987" data-mp="25e1i3697006p">
        Privacy Policy
      </a>{' '}
      ·{' '}
      <a href="/terms" className={linkClass} data-id="element-988" data-mp="2accpzbfxg0ma">
        Terms
      </a>{' '}
      ·{' '}
      <a href="/ca-notice" className={linkClass} data-id="element-989" data-mp="2fc8s1552dhz7">
        Do Not Sell or Share My Info
      </a>
    </p>;
}